<template>
<div class="mt-5 pt-2">
    <h5 class="text-center mb-5 mt-5">Enlases</h5>
    <div class="container">
        <mdb-row>
            <mdb-col col="12" lg="4" md='4' sm="6">
                <mdb-card>
                    <mdb-view hover>
                        <a href="#!">
                            <mdb-card-image :src="mofongo" alt="Card image cap"></mdb-card-image>
                            <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
                        </a>
                    </mdb-view>
                    <!-- <mdb-row class="justify-content-end mr-2 mb-4">
           <transition name="social-gplus-btn">
            <mdb-btn v-if="show" tag="a" floating action class="">
              <mdb-icon fas icon="map-marker" />
            </mdb-btn>
          </transition>

          <transition name="social-gplus-btn">
            <mdb-btn v-if="show" tag="a" floating action class="">
              <mdb-icon fas icon="external-link-alt" />
            </mdb-btn>
          </transition>
          <mdb-btn tag="a" floating action gradient="aqua-gradient" @click="show = !show">
            <mdb-icon icon="search" />
          </mdb-btn>
        </mdb-row> -->

                    <mdb-card-body class="text-center">
                        <mdb-card-title centered>Restarauntes</mdb-card-title>
                        <!-- <hr /> -->

                    </mdb-card-body>
                </mdb-card>

            </mdb-col>

            <mdb-col col="12" lg="4" md='4' sm="6" class="mb-5">
                <mdb-card>
                    <mdb-view hover>
                        <a href="#!">
                            <mdb-card-image :src="parguera" alt="Card image cap"></mdb-card-image>
                            <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
                        </a>
                    </mdb-view>
                    <!-- <mdb-row class="justify-content-end mr-2 mb-4">
           <transition name="social-gplus-btn">
            <mdb-btn v-if="show" tag="a" floating action class="">
              <mdb-icon fas icon="map-marker" />
            </mdb-btn>
          </transition>

          <transition name="social-gplus-btn">
            <mdb-btn v-if="show" tag="a" floating action class="">
              <mdb-icon fas icon="external-link-alt" />
            </mdb-btn>
          </transition>
          <mdb-btn tag="a" floating action gradient="aqua-gradient" @click="show = !show">
            <mdb-icon icon="search" />
          </mdb-btn>
        </mdb-row> -->

                    <mdb-card-body class="text-center">
                        <mdb-card-title centered>Parguera</mdb-card-title>
                        <!-- <hr /> -->

                    </mdb-card-body>
                </mdb-card>

            </mdb-col>

            <mdb-col col="12" lg="4" md='4' sm="6">
                <mdb-card>
                    <mdb-view hover>
                        <a href="#!">
                            <mdb-card-image :src="manglillo" alt="Card image cap"></mdb-card-image>
                            <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
                        </a>
                    </mdb-view>
                    <!-- <mdb-row class="justify-content-end mr-2 mb-4">
           <transition name="social-gplus-btn">
            <mdb-btn v-if="show" tag="a" floating action class="">
              <mdb-icon fas icon="map-marker" />
            </mdb-btn>
          </transition>

          <transition name="social-gplus-btn">
            <mdb-btn v-if="show" tag="a" floating action class="">
              <mdb-icon fas icon="external-link-alt" />
            </mdb-btn>
          </transition>
          <mdb-btn tag="a" floating action gradient="aqua-gradient" @click="show = !show">
            <mdb-icon icon="search" />
          </mdb-btn>
        </mdb-row> -->

                    <mdb-card-body class="text-center">
                        <mdb-card-title centered>Manglillo</mdb-card-title>
                        <!-- <hr /> -->

                    </mdb-card-body>
                </mdb-card>

            </mdb-col>

            <mdb-col col="12" lg="4" md='4' sm="6">
                <mdb-card>
                    <mdb-view hover>
                        <a href="#!">
                            <mdb-card-image :src="guanica" alt="Card image cap"></mdb-card-image>
                            <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
                        </a>
                    </mdb-view>
                    <!-- <mdb-row class="justify-content-end mr-2 mb-4">
           <transition name="social-gplus-btn">
            <mdb-btn v-if="show" tag="a" floating action class="">
              <mdb-icon fas icon="map-marker" />
            </mdb-btn>
          </transition>

          <transition name="social-gplus-btn">
            <mdb-btn v-if="show" tag="a" floating action class="">
              <mdb-icon fas icon="external-link-alt" />
            </mdb-btn>
          </transition>
          <mdb-btn tag="a" floating action gradient="aqua-gradient" @click="show = !show">
            <mdb-icon icon="search" />
          </mdb-btn>
        </mdb-row> -->

                    <mdb-card-body class="text-center">
                        <mdb-card-title centered>Guanica</mdb-card-title>
                        <!-- <hr /> -->

                    </mdb-card-body>
                </mdb-card>

            </mdb-col>

            <mdb-col col="12" lg="4" md='4' sm="6">
                <mdb-card>
                    <mdb-view hover>
                        <a href="#!">
                            <mdb-card-image :src="ps" class="img-fluid" alt="Card image cap"></mdb-card-image>
                            <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
                        </a>
                    </mdb-view>
                    <!-- <mdb-row class="justify-content-end mr-2 mb-4">
           <transition name="social-gplus-btn">
            <mdb-btn v-if="show" tag="a" floating action class="">
              <mdb-icon fas icon="map-marker" />
            </mdb-btn>
          </transition>

          <transition name="social-gplus-btn">
            <mdb-btn v-if="show" tag="a" floating action class="">
              <mdb-icon fas icon="external-link-alt" />
            </mdb-btn>
          </transition>
          <mdb-btn tag="a" floating action gradient="aqua-gradient" @click="show = !show">
            <mdb-icon icon="search" />
          </mdb-btn>
        </mdb-row> -->

                    <mdb-card-body class="text-center">
                        <mdb-card-title centered>Playa Santa</mdb-card-title>
                        <!-- <hr /> -->

                    </mdb-card-body>
                </mdb-card>

            </mdb-col>

            <mdb-col col="12" lg="4" md='4' sm="6">
                <mdb-card>
                    <mdb-view hover>
                        <a href="#!">
                            <mdb-card-image :src="gilligan" alt="Card image cap"></mdb-card-image>
                            <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
                        </a>
                    </mdb-view>
                    <!-- <mdb-row class="justify-content-end mr-2 mb-4">
           <transition name="social-gplus-btn">
            <mdb-btn v-if="show" tag="a" floating action class="">
              <mdb-icon fas icon="map-marker" />
            </mdb-btn>
          </transition>

          <transition name="social-gplus-btn">
            <mdb-btn v-if="show" tag="a" floating action class="">
              <mdb-icon fas icon="external-link-alt" />
            </mdb-btn>
          </transition>
          <mdb-btn tag="a" floating action gradient="aqua-gradient" @click="show = !show">
            <mdb-icon icon="search" />
          </mdb-btn>
        </mdb-row> -->

                    <mdb-card-body class="text-center">
                        <mdb-card-title centered>Playa Gilligan</mdb-card-title>
                        <!-- <hr /> -->

                    </mdb-card-body>
                </mdb-card>

            </mdb-col>

            <!-- <mdb-col col="12" lg="4" md='4' sm="6">
            <mdb-card>
                <mdb-view hover>
                    <a href="#!">
                        <mdb-card-image :src="bosque" alt="Card image cap"></mdb-card-image>
                        <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
                    </a>
                </mdb-view>

                <mdb-card-body class="text-center">
                    <mdb-card-title centered>Bosque Seco</mdb-card-title>

                </mdb-card-body>
            </mdb-card>

        </mdb-col> -->

        </mdb-row>
    </div>

</div>
</template>

<script>
import playa_santa from '../assets/playa_santa.jpg'
import parguera from '../assets/parguera.jpg'
import guanica from '../assets/guanica.jpg'
import manglillo from '../assets/manglillo.jpg'
import bosque from '../assets/bosque2.jpg'
import gilligan from '../assets/gilligan.jpg'
import mofongo from '../assets/food2.jpg'
import {
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbView,
    mdbMask,
    mdbRow,
    mdbCol,
}
from 'mdbvue'

export default {
    name: 'Enlases',
    data() {
        return {
            // hero_image: portada,
            // quote: 'Paradise Apartments',
            // by: 'El Paraiso esta a su Alcance',
            show: false,
            show_img: 'pg',
            ps: playa_santa,
            parguera: parguera,
            guanica: guanica,
            manglillo: manglillo,
            bosque: bosque,
            gilligan: gilligan,
            mofongo: mofongo,

        }
    },

    components: {
        mdbCard,
        mdbCardImage,
        mdbCardBody,
        mdbCardTitle,
        mdbView,
        mdbMask,
        mdbRow,
        mdbCol,
    }
}
</script>
